import React from 'react';
import OurMission from '../components/organization/OurMission';
import OurVision from '../components/organization/OurVision';
import OurStory from '../components/organization/OurStory';
import Breadcrumbs from '../components/Breadcrumb';

const Organization = () => {
  const breadcrumbItems = ['Organization', 'Our Story, Mission and Vision'];

  return (
    <div>
        <div className='mt-16 sm:mt-20 md:mt-24 lg:mt-24 mx-6 sm:mx-8 md:mx-10 lg:mx-20'>
          <Breadcrumbs item1={breadcrumbItems[0]} item2={breadcrumbItems[1]} />
        </div>
        <div>
          <OurStory />
        </div>
        <div id="our-mission">
          <OurMission />
        </div>
        <div id="our-vision">
          <OurVision />
        </div>
        <div className='mt-24'></div>
    </div>
  )
}

export default Organization
